import styled from 'styled-components';
import { Card } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const SummaryCard = styled(Card)`
  margin-top: 24px;
  background-color: #fff;

  .ant-card-body {
    padding: 20px;
  }
`;

export const SummaryHeader = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-bottom: 20px;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 20px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #f78e1e;
  margin-bottom: 12px;

  .anticon {
    font-size: 16px;
    color: #f78e1e;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 16px;
  }
`;

export const Section = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 24px;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  margin: 8px 0 20px 0;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 16px;
  }
`;

export const InfoLabel = styled.span`
  color: #000;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 16px;
  }
`;

export const InfoValue = styled.span`
  color: #000;
  font-weight: 700;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    font-size: 16px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    margin-top: 100px;
    flex-direction: column;
  }
`;

export const ClearButton = styled.button`
  flex: 1;
  background: #fff;
  color: #ff4d4f;
  border: 1px solid #ff4d4f;
  padding: 8px;
  font-size: 0.875rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff4d4f;
    color: #fff;
  }

  &:disabled {
    background: #f5f5f5;
    color: #d9d9d9;
    border-color: #d9d9d9;
    cursor: not-allowed;
  }
`;

export const ActionButton = styled.button`
  flex: 1;
  background: #f78e1e;
  color: white;
  border: none;
  padding: 8px;
  font-size: 0.875rem;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .anticon {
    font-size: 16px;
  }

  &:hover {
    background: #e67d0d;
  }

  &:disabled {
    background: #d9d9d9;
    cursor: not-allowed;
  }
`;
